import {Component, Input, OnInit, Output} from '@angular/core';
import {
  fdeStatusObject
} from '../../../../common/it-interface';
import {convertToSnakeCase} from "../../../../common/it-utils";
import { SIDE_NAV_TITLES, FDE_STATUS_LABEL, FDE_STATUS_VALUE } from "../../../../common/it-constants";
import { FdeDeoDistributorService } from "../../../eod-distributor.service";
import {forkJoin} from "rxjs";

@Component({
  selector: 'app-fde-report-table',
  templateUrl: './fde-report-table.component.html',
  styleUrls: ['./fde-report-table.component.scss']
})
export class FdeReportTableComponent implements OnInit{
  @Input() tableDataShow: string;
  @Input() listOfFdeStatusReport: fdeStatusObject;
  @Output() listOfFdeBbgNavByHstDate = [];
  @Output() listOfFdeMsNavByHstDate = [];
  @Output() listOfFdeCrNavByHstDate = [];
  @Output() listOfBbgHoldingByHstDate = [];
  @Output() subLoading = true;
  loading = true;
  display = false;
  openingMode = 'new';
  formTitle = '';
  statuses: any[];
  fundDayEndReportKey = convertToSnakeCase(SIDE_NAV_TITLES.fundDayEndReport);
  sendNavAndHoldingData: any;
  showAlertPopup = false;
  message: string;
  check = false;
  genFdeReportTitle = 'Upload NAV and Generate Report For a fund';
  viewTitle = 'View Detail';
  sendFdeReportTitle = 'Send NAV and Holding Report for a fund';

  constructor( private fdeDeoDistributorService: FdeDeoDistributorService ) { }

  ngOnInit() {
    this.statuses = [
      {label: FDE_STATUS_LABEL.NA, value: FDE_STATUS_VALUE.NA},
      {label: FDE_STATUS_LABEL.Ready, value: FDE_STATUS_VALUE.Ready},
      {label: FDE_STATUS_LABEL.NewSecurity, value: FDE_STATUS_VALUE.NewSecurity},
      {label: FDE_STATUS_LABEL.Fail, value: FDE_STATUS_VALUE.Fail}
    ]

    this.getLists();
  }

  // refresh Status of fde-report
  onClickRefreshStatusButton() {
    this.getLists()
  }

  // Send All of fde-report
  onClickSendAllButton() {
    alert("Wait function!!!")
    // Trigger FDE NAV and holding emails to BBG, MS, CR, etc…
  }

  // @ts-ignore
  setOnHide() {
    this.listOfFdeBbgNavByHstDate = [];
    this.listOfFdeMsNavByHstDate = [];
    this.listOfFdeCrNavByHstDate = [];
    this.listOfBbgHoldingByHstDate = [];
  }


  getLists() {
    // 获取fde status report 的列表
    this.getFdeStatusReport();
  }

  // api function call to get list of getFdeStatusReport records
  getFdeStatusReport() {
    this.loading = true;
    this.fdeDeoDistributorService.fdeDeoDistributorQuery().then(response => {
      if (response['status'] && response['status'] === 200) {
        this.listOfFdeStatusReport = response['data'];
        this.loading = false;
      } else {
        // this.showWarningPopup('Records not found');
        this.loading = false;
      }
    }).catch(err => {
      // this.showWarningPopup('Records not found');
      this.loading = false;
    });
  }

  generatorOnMouse(value) {
    alert(123);
  }

  /**
   * generator FDE Report
   * @param value
   */
  generatorFdeReport(value) {
    this.loading = true;
    let tradarFundCode = value['tradarFundCode'];
    let hstDate = value['hstDate'];
    let settlement = value['settlement'];
    this.fdeDeoDistributorService.fdeGeneratorReport(tradarFundCode, hstDate, settlement).then(response => {
      if (response['status'] && response['status'] === 200) {
        this.loading = false;
      } else {
        this.loading = false;
      }
    }).catch(err => {
      this.loading = false;
    });
  }

  /**
   * send Nav And Holding Report
   * @param value
   */
  sendNavAndHoldingReport(value) {
    this.showAlertPopup = true;
    this.message = 'Are you really going to send the NAV and Holding Report to BBG Morning Star and clients?';
    this.check = false;
    this.sendNavAndHoldingData = value;
  }

  onClickYes(value) {
    this.loading = true;
    let tradarFundCode = value['tradarFundCode'];
    let hstDate = value['hstDate'];
    this.fdeDeoDistributorService.sendNavAndHoldingReport(tradarFundCode, hstDate).then(response => {
      if (response['status'] && response['status'] === 200) {
        this.loading = false;
      } else {
        this.loading = false;
      }
    }).catch(err => {
      this.loading = false;
    });
  }

  // to view fund data
  // api function call to get list of get Fde Bloomberg NAV records
  // api function call to get list of get Fde Morning Star NAV records
  // api function call to get list of get Fde Morning Star NAV records
  viewFundData(value) {
    this.formTitle = 'NAV REPORT';
    this.openingMode = 'edit';
    this.display = true;
    let tradarFundCode = value['tradarFundCode'];
    let hstDate = value['hstDate'];
    this.subLoading = true;
    forkJoin(
      this.fdeDeoDistributorService.fdeBloombergQuery(tradarFundCode, hstDate),
      this.fdeDeoDistributorService.fdeMorningStarQuery(tradarFundCode, hstDate),
      this.fdeDeoDistributorService.fdeClientRequestQuery(tradarFundCode, hstDate),
      this.fdeDeoDistributorService.fdeBloombergHoldingQuery(tradarFundCode, hstDate)
    ).subscribe(([responseBbgNav, responseMsNav, responseCrNav, responseBbgHolding]) => {
      if (responseBbgNav['status'] === 200) {
        this.listOfFdeBbgNavByHstDate = responseBbgNav['data'];
      }
      if (responseMsNav['status'] === 200) {
        this.listOfFdeMsNavByHstDate = responseMsNav['data'];
      }
      if (responseCrNav['status'] === 200) {
        this.listOfFdeCrNavByHstDate = responseCrNav['data'];
      }
      if (responseBbgHolding['status'] === 200) {
        this.listOfBbgHoldingByHstDate = responseBbgHolding['data'];
      }
      this.subLoading = false;
    });
  }

}
